// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { TargetTypeSchema } from '../inputTypeSchemas/TargetTypeSchema'
import { FindingStatusSchema } from '../inputTypeSchemas/FindingStatusSchema'
import { FindingSeveritySchema } from '../inputTypeSchemas/FindingSeveritySchema'
import { SignalCategorySchema } from '../inputTypeSchemas/SignalCategorySchema'
import { PreventionControlTypeSchema } from '../inputTypeSchemas/PreventionControlTypeSchema'
import { PreventionControlStatusSchema } from '../inputTypeSchemas/PreventionControlStatusSchema'
import { InfraImpactSchema } from '../inputTypeSchemas/InfraImpactSchema'
import { BusinessRiskSchema } from '../inputTypeSchemas/BusinessRiskSchema'
import { FindingTypeSchema } from '../inputTypeSchemas/FindingTypeSchema'
import { FindingTypeSourceSchema } from '../inputTypeSchemas/FindingTypeSourceSchema'
import { CvssScoreStatusSchema } from '../inputTypeSchemas/CvssScoreStatusSchema'
import { SeveritySourceSchema } from '../inputTypeSchemas/SeveritySourceSchema'

/////////////////////////////////////////
// FINDING SCHEMA
/////////////////////////////////////////

export const FindingSchema = z.object({
  targetType: TargetTypeSchema,
  status: FindingStatusSchema,
  severity: FindingSeveritySchema,
  category: SignalCategorySchema.nullable(),
  preventionControlType: PreventionControlTypeSchema.nullable(),
  preventionStatus: PreventionControlStatusSchema.nullable(),
  pendingProposedSeverity: FindingSeveritySchema.nullable(),
  infraImpact: InfraImpactSchema.nullable(),
  businessRisk: BusinessRiskSchema.nullable(),
  findingType: FindingTypeSchema.nullable(),
  findingTypeSource: FindingTypeSourceSchema.nullable(),
  cvssScoreStatus: CvssScoreStatusSchema.nullable(),
  severitySource: SeveritySourceSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  targetId: z.string(),
  executionStateId: z.string().nullable(),
  traceThreadId: z.string().nullable(),
  postAttackTraceId: z.string().nullable(),
  signalId: z.string().nullable(),
  title: z.string(),
  description: z.string().nullable(),
  shortDescription: z.string().nullable(),
  attackCapabilities: z.string().nullable(),
  poc: z.string().nullable(),
  pocBlocks: JsonValueSchema.nullable(),
  businessImpact: z.string().nullable(),
  mitigationPlan: z.string().nullable(),
  findingReport: z.string().nullable(),
  cweIds: z.string().array(),
  owaspCategory: z.string().nullable(),
  pocEnc: z.string().nullable(),
  pocBlocksEnc: z.string().nullable(),
  businessImpactEnc: z.string().nullable(),
  mitigationPlanEnc: z.string().nullable(),
  findingReportEnc: z.string().nullable(),
  filePath: z.string().nullable(),
  metadata: JsonValueSchema.nullable(),
  assignedTo: z.string(),
  discoveryDate: z.coerce.date(),
  publishedAt: z.coerce.date().nullable(),
  isPublished: z.boolean().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  reportsId: z.string().array(),
  encryptionKeyEnc: z.string().nullable(),
  exploitationGuide: z.string().nullable(),
  executionScript: z.string().nullable(),
  exploitationGuideEnc: z.string().nullable(),
  executionScriptEnc: z.string().nullable(),
  pocScriptEnc: z.string().nullable(),
  pocScript: z.string().nullable(),
  pocScriptBlockedByGuardrails: z.boolean().nullable(),
  pocScriptGuardrailsFeedback: z.string().nullable(),
  remediationPlan: z.string().nullable(),
  remediationPlanGeneratedAt: z.coerce.date().nullable(),
  remediationPlanFailureReason: z.string().nullable(),
  findingUpdateComment: z.string().nullable(),
  hasRetests: z.boolean(),
  retestThreadIds: z.string().array(),
  constituentFindingIds: z.string().array(),
  preventionControlRef: z.string().nullable(),
  preventionActivatedAt: z.coerce.date().nullable(),
  findingTypeReason: z.string().nullable(),
  cvssVersion: z.string().nullable(),
  cvssScoreRequestedAt: z.coerce.date().nullable(),
  cvssScoreInputEnc: z.string().nullable(),
})

export type Finding = z.infer<typeof FindingSchema>

export default FindingSchema;
